<template>
  <b-card>
    <div class="d-flex flex-wrap ">
      <b-form-group
        label="کاربر"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <select-box
          v-model="user_id"
          label="text"
          class="w-100"
          select="id"
          url="user"
          searchable
        />
      </b-form-group>
      <b-form-group
        label="تاریخ"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <date-picker
          v-model="created_at"
          autocomplete="on"
          id="created_at"
          range
          clearable
          auto-submit
          :editable='false'
          name="created_at"
          format="jYYYY/jM/jD HH:mm"
          display-format="jYYYY/jM/jD"
        />
      </b-form-group>
      <b-form-group
        label="مبلغ"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <b-form-input
          v-model="amount"
          placeholder="مبلغ مورد نظر را وارد کنید"
          type="number"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="کد رهگیری"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <b-form-input
          v-model.trim="transactions_reference_code"
          placeholder="کد رهگیری را وارد کنید"
          type="number"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label="وضعیت"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-md-1 pr-50 px-0"
      >
        <select-box
          v-model="status"
          :lists="statusFilter"
          label="text"
          class="w-100"
          select="val"
        />
      </b-form-group>
      <b-form-group label="فیلتر بر اساس" class="mb-1 col-lg-3 col-sm-6 col-12 pr-1 px-0">
        <select-box
          v-model="auditable_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="auditable_type"
        class="mb-1 col-lg-3 col-sm-6 col-12 pr-1 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="auditable_id"
          label="text"
          class="w-100"
          select="id"
          :url="auditable_type"
          searchable
        />
      </b-form-group>
     
    </div>
        <div class="d-flex flex-wrap mb-1">

       <b-form
        class="d-flex align-items-center  col-lg-4 col-sm-6 col-12 mt-1 pr-md-1 pr-50 px-0"
        @submit.prevent="onSearch"
      >
        <b-form-input v-model.trim="search" />
        <b-button variant="primary" class="ml-sm-1 mt-sm-0 ml-50" type="submit">
          جستجو
        </b-button>
      </b-form>
    </div>
    <data-table
      :fields="fields"
      :items="invoices"
      :loading="loading"
      @onRowClicked="
        $router.push({
          name: 'show-invoice',
          params: { id: $event.id },
        })
      "
    >
      <template #id="{ data }">
        {{ data.item.id }}
      </template>
      <template #user="{ data }">
        {{ data.item.user.first_name + " " + data.item.user.last_name }}
      </template>
      <template #created_at="{ data }">
        {{ calcDate(data.item.created_at) }}
      </template>
      <template #final_amount="{ data }">
        <span class="text-success">
          {{ numberWithCommas(data.item.final_amount) }} تومان
        </span>
      </template>
      <template #transaction="{ data }">
        {{ checkTransaction(data.item) }}
      </template>
      <template #item="{ data }">
        <div
          v-if="
            data.item.items &&
            data.item.items.items &&
            data.item.items.items.length
          "
          style="white-space: nowrap"
        >
          <template v-if="data.item.items.items[0].model_type == 'penalty'">
            <b-badge class="my-50" variant="danger">جریمه</b-badge>
            <div>دوره : {{ data.item.items.items[0].model.course.name }}</div>
            <div class="my-50">
              جلسه : {{ data.item.items.items[0].model.session.name }}
            </div>
            <div>
              تمرین : {{ data.item.items.items[0].model.exercise.title }}
            </div>
          </template>
          <template v-else>
            {{ data.item.items.items[0].model.name }}
          </template>
        </div>
        <span v-else>'-'</span>
      </template>
      <!-- <template #detail="{ data }">
        <b-button
          size="sm"
          variant="flat-secondary"
          @click="data.toggleDetails"
        >
          <span class="ml-50">مشاهده جزییات</span>
        </b-button></template
      > -->
      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'warning'
              : data.item.status == 2
              ? 'success'
              : 'danger'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "در حال پرداخت"
              : data.item.status == 2
              ? "پرداخت شده"
              : "لغو شده"
          }}
        </b-badge>
        <b-button
          class="ml-2"
          size="sm"
          v-if="data.item.status == 0"
          variant="success"
          :to="{ name: 'checkout', query: { invoice_id: data.item.id } }"
          >پرداخت</b-button
        >
      </template>
      <template #actions="{ data }">
        <b-button
          size="sm"
          variant="flat-primary"
          :to="{
            name: 'show-invoice',
            params: { id: data.item.id },
          }"
          style="white-space: nowrap"
        >
          <feather-icon icon="EyeIcon" />
          <span class="ml-50">مشاهده</span>
        </b-button>
      </template>
      <!-- <template #row-details="{ data }"> </template> -->
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-6 ml-auto d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="my-2 d-flex justify-content-center"
        ></b-pagination>
      </div>
      <b-form
        @submit.prevent="goTo"
        class="d-flex col-md-3 align-items-center justify-content-md-end pr-0"
      >
        <div>
          <b-button type="submit" size="sm" variant="primary"
            >رفتن به
          </b-button>
        </div>
        <b-form-group label-for="to-page" class="w-50 ml-50 mb-0">
          <b-form-input
            id="to-page"
            type="number"
            size="sm"
            :max="pagination.total_pages"
            min="1"
            v-model="choosenPage"
          />
        </b-form-group>
      </b-form>
    </div>
    <b-modal v-model="visible" hide-footer>
      <div class="my-1" v-if="invoiceStatus.message">
        {{ invoiceStatus.message }}
      </div>

      <div class="my-1" v-if="invoiceStatus.transaction_id">
        شناسه تراکنش‌: {{ invoiceStatus.transaction_id }}
      </div>
      <div class="my-1" v-if="invoiceStatus.reference_code">
        کد پیگیری : {{ invoiceStatus.reference_code }}
      </div>

      <div v-if="invoiceStatus.amount" class="my-1">
        مبلغ : {{ numberWithCommas(invoiceStatus.amount) + " " + "تومان" }}
      </div>
    </b-modal>
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";
import qs from "qs";
export default {
  components: {
    DataTable,
    BButton,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BModal,
    BForm,
    BFormInput,
    BFormGroup,
    SelectBox,
  },
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      selectAll: false,
      removeinvoicesData: [],
      choosenPage: 1,
      invoices: [],
      search: "",
      loading: false,
      url: "/panel/invoices",
      currentPage: 1,
      pagination: {},
      visible: false,
      invoiceStatus: {
        status: "",
        message: "",
        reference_code: "",
        transaction_id: "",
      },
      types: [
        {
          id: 1,
          text: "ترم",
          val: "semester",
        },
        {
          id: 2,
          text: "دوره",
          val: "course",
        },
      ],
      statusFilter: [
        {
          id: 1,
          text: "لغو شده",
          val: "3",
        },
        {
          id: 2,
          text: "پرداخت شده",
          val: "2",
        },
      ],
      fields: [
        { key: "id", label: "شناسه" },
        { key: "user", label: "نام کاربر" },
        { key: "created_at", label: "تاریخ فاکتور" },
        { key: "final_amount", label: "مبلغ نهایی فاکتور" },
        { key: "transaction", label: "کد پیگیری پرداخت" },
        { key: "item", label: "شرح" },
        { key: "status", label: "وضعیت" },
        { key: "actions", label: "عملیات" },
      ],
      amount: "",
      transactions_reference_code: "",
      created_at: [],
      status: "",
      user_id: "",
      interval: null,
      auditable_type: "",
      auditable_id: "",
    };
  },
  computed: {
    selectedItems() {
      return {
        amount: this.amount,
        transactions_reference_code: this.transactions_reference_code,
        created_at: this.created_at,
        status: this.status,
        user_id: this.user_id,
        auditable_type: this.auditable_type,
        auditable_id: this.auditable_id,
      };
    },
  },
  watch: {
    $route: {
      handler(val) {
        this.getInvoices();
      },
      immediate: true,
      deep: true,
    },
    currentPage(val) {
      this.choosenPage = val;
      if (val != this.$route.query.page) {
        this.$router.push({
          name: "invoices",
          query: {
            ...this.$route.query,
            page: val,
          },
        });
      }
    },
    search(val) {
      if (!val && this.$route.query.key) {
        if (this.$route.query.filters) {
          this.$router.push({
            name: "invoices",
            query: {
              filters: this.$route.query.filters,
            },
          });
        } else {
          this.$router.push({
            name: "invoices",
          });
        }
      }
    },
    selectedItems(val) {
      let filters = {};
      !val.auditable_type && (this.auditable_id = "");
      val.auditable_type == "course" &&
        val.auditable_id &&
        (filters.course_id = val.auditable_id);
      val.auditable_type == "semester" &&
        val.auditable_id &&
        (filters.semester_id = val.auditable_id);
      val.amount &&
        (filters.amount = {
          value: val.amount,
          operator: "=",
        });
      val.transactions_reference_code &&
        (filters.transactions_reference_code = val.transactions_reference_code);
      val.created_at.length && 
        (filters.created_at = {
          from: this.toGorgian(val.created_at[0]),
          to: val.created_at[1]
            ? this.toGorgian(val.created_at[1])
            : this.toGorgian(val.created_at[0]),
        });
      val.status && (filters.status = val.status);
      val.user_id && (filters.user_id = val.user_id);
      this.debounceEvent(() => {
        this.$router.push({
          name: "invoices",
          query: {
            ...this.$route.query,
            filters,
          },
        });
      }, 1000);
    },
  },
  async created() {
    if (this.$route.query.filters || this.$route.query.key) {
      this.$router.push({
        name: "invoices",
      });
    }
    if (this.$route.query && this.$route.query.status) {
      await Object.keys(this.invoiceStatus).map((key) => {
        this.invoiceStatus[key] = this.$route.query[key];
      });
      this.visible = true;
    }
  },

  methods: {
    debounceEvent(callback, time) {
      clearTimeout(this.interval);
      this.interval = setTimeout(() => {
        this.interval = null;
        callback();
      }, time);
    },
    goTo() {
      this.currentPage = this.choosenPage;
    },
    async onSearch() {
      if (this.search) {
        this.$router.push({
          name: "invoices",
          query: {
            ...this.$route.query,
            key: this.search,
          },
        });
      }
    },
    checkTransaction(item) {
      let trans = item.transactions.transactions.find(
        (transaction) => transaction.reference_code != null
      );
      if (trans != undefined && Object.keys(trans).length) {
        return trans.reference_code;
      } else {
        return "-";
      }
    },
    async getInvoices() {
      this.loading = true;
      try {
        const params = {
          per_page: 8,
          ...this.$route.query,
          includes: [
            "user",
            "items.model.exercise",
            "items.model.session",
            "items.model.course",
            "transactions",
          ],
        };
        const { data } = await this.$http.get(this.url, {
          params,
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.invoices = data.data.invoices;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
<style lang="scss">
.vpd-input-group {
  .vpd-icon-btn {
    margin-bottom: 0;
  }
  .form-control {
    border-radius: 0 5px 5px 0;
  }
}
</style>
